import { createContext, useContext, type ReactNode } from 'react';
import usePPJK from '@hooks/use-ppjk';

interface PPJKContextType {
  nomorPpjk: string | null;
  isLoading: boolean;
  updatePpjk: (newPpjk: string) => void;
  getPpjkWithFallback: (fallback?: string) => string | null;
  clearPpjk: () => void;
}

const PPJKContext = createContext<PPJKContextType | undefined>(undefined);

interface PPJKProviderProps {
  children: ReactNode;
}

export function PPJKProvider({ children }: PPJKProviderProps) {
  const ppjkData = usePPJK();

  return (
    <PPJKContext.Provider value={ppjkData}>
      {children}
    </PPJKContext.Provider>
  );
}

export function usePPJKContext() {
  const context = useContext(PPJKContext);
  if (context === undefined) {
    throw new Error('usePPJKContext must be used within a PPJKProvider');
  }
  return context;
}

export default PPJKContext;